import Assignee from './Assignee'
export default Assignee

export { getFullNameForAssignee, toUser, fromUser } from './Assignee'



// WEBPACK FOOTER //
// ./src/components/Assignee/index.js